var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Status',{attrs:{"value":_vm.connected,"ok-label":_vm.$t('connected'),"ko-label":_vm.$t('disconnected')}})}
var staticRenderFns = []

export { render, staticRenderFns }